import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
var useCreatePatientSummary = function useCreatePatientSummary(workspaceId, patientUid, tz_info) {
  return useMutation(function () {
    return servicesUtils.postService("workspaces/".concat(workspaceId, "/patient/").concat(patientUid, "/patient_summary/"), {
      tz_info: tz_info
    });
  });
};
export default useCreatePatientSummary;